import COMBaseRegulation from "../com_base_regulation";
import TempAccountMessageRegulationHelper from "../../../helpers/temp_account_message_helper";

export default class GibRegulation extends COMBaseRegulation {
    static CLASS = 'GibRegulation';

    showTempAccountMessage() {
        TempAccountMessageRegulationHelper.create({
          serviceFactory: this.serviceFactory
        }).showTempAccountMessage({
          messageKey: 'gib_temp_account_message'
        });
      }
}